module.exports = __webpack_public_path__ + "img/give-up.78ecea40.svg";